import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Home from '../screens/Home/Home';
import Profile from '../screens/Profile/Profile';
import PublicProfile from '../screens/PublicProfile/PublicProfile';
import GameDetails from '../screens/GameDetails/GameDetails';
import LoginRoutes from './LoginRoutes';
import PrivacyPolicy from '../components/PrivacyPolicy/PrivacyPolicy';
import Terms from '../components/PrivacyPolicy/Terms';
import CookiesPolicy from '../components/PrivacyPolicy/CookiesPolicy';
import FacilityRules from '../components/PrivacyPolicy/FacilityRules';
import DeleteAccount from '../components/PrivacyPolicy/DeleteAccount';
import { ROUTES } from '../utils/appRoutes';
import { buildAuthPathWithNext, getCurrentAppPath } from '../utils/authRedirect';

function AppRoutes({ 
  isAuthenticated, 
  onLogin, 
  refreshTokens, 
  handleLogout,
  userData,
  onUserUpdate,
  onProfilePictureVersionUpdate,
  profilePictureVersion
}) {
  const location = useLocation();
  const loginPath = buildAuthPathWithNext(
    ROUTES.LOGIN,
    getCurrentAppPath(location)
  );

  return (
    <Routes>
      <Route path="/" element={<Home user={userData} isAuthenticated={isAuthenticated} />} />
      <Route
        path="/games/:gameId"
        element={
          <GameDetails
            refreshTokens={refreshTokens}
            handleLogout={handleLogout}
          />
        }
      />
      <Route
        path="/profile"
        element={
          isAuthenticated ? (
            <Profile
              refreshTokens={refreshTokens}
              handleLogout={handleLogout}
              user={userData}
              onUserUpdate={onUserUpdate}
              onProfilePictureVersionUpdate={onProfilePictureVersionUpdate}
              profilePictureVersion={profilePictureVersion}
            />
          ) : (
            <Navigate to={loginPath} replace />
          )
        }
      />
      <Route
        path={`${ROUTES.PLAYERS}/:playerId`}
        element={
          <PublicProfile
            isAuthenticated={isAuthenticated}
            currentUser={userData}
          />
        }
      />
      <Route path="/*" element={<LoginRoutes onLogin={onLogin} />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/cookies" element={<CookiesPolicy />} />
      <Route path={ROUTES.FACILITY_RULES} element={<FacilityRules />} />
      <Route path={ROUTES.DELETE_ACCOUNT} element={<DeleteAccount />} />
    </Routes>
  );
}

export default AppRoutes;
